define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'model/Context',
	'recoverystrategy/WebstartRecoveryStrategy',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/RecoveryStrategyView',
	'view/WebstartRecoveryStrategyView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/RecoveryStrategyState_strings'
], function (
	Util,
	UiUtil,
	Context,
	WebstartRecoveryStrategy,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	ProviderInfoView,
	NavigationView,
	RecoveryStrategyView,
	WebstartRecoveryStrategyView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * RecoveryStrategyState class
	 */
	function RecoveryStrategyState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_recoveryStrategyView = new RecoveryStrategyView(recoveryStrategyClickHandler),
			_controlBarView = new ControlBarView(),
			_data = null,
			_currentRecoveryStrategy = null;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.choose_recovery_strategy);

		_controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.core().recoveryStrategyManager().stopRecoveryStrategies();
			_uiStateManager.back();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'recovery_strategy');


		// private methods

		function strategySucceeded(recoveryStrategy) {
			if (recoveryStrategy.id() === _currentRecoveryStrategy.id()) {
				EventListenerRegistry.removeListener('RECOVERY_STRATEGY_FAILED', strategyFailed);

				_uiStateManager.change('activation', _data['activationData']);
			}
		}

		function strategyFailed(recoveryStrategy) {
			if (recoveryStrategy.id() === _currentRecoveryStrategy.id()) {
				EventListenerRegistry.removeListener('RECOVERY_STRATEGY_SUCCEEDED', strategySucceeded);

				_recoveryStrategyView.hideLoadingIndicator();
			}
		}

		function handleWebstartRecoveryStrategy(showView) {
			var webstartRecoveryStrategyView;

			function removeOverlay() {
				webstartRecoveryStrategyView.get().remove();
				_recoveryStrategyView.showLoadingIndicator();
			}

			webstartRecoveryStrategyView = new WebstartRecoveryStrategyView(function () {
					removeOverlay();
					Util.callCallbacks(showView['isInstalled']);
				}, function () {
					Util.callCallbacks(showView['isNotInstalled']);
				}, function () {
					removeOverlay();
					Util.callCallbacks(showView['startApp']);
				});

			_recoveryStrategyView.hideLoadingIndicator();
			_recoveryStrategyView.get().append(webstartRecoveryStrategyView.get());
		}

		function recoveryStrategyClickHandler(recoveryStrategy) {
			_currentRecoveryStrategy = recoveryStrategy;

			EventListenerRegistry.addOneTimeListener('RECOVERY_STRATEGY_SUCCEEDED', strategySucceeded);
			EventListenerRegistry.addOneTimeListener('RECOVERY_STRATEGY_FAILED', strategyFailed);

			_recoveryStrategyView.setLoadingText(Strings.waiting_for + ' ' + _currentRecoveryStrategy.name() + '...');
			_recoveryStrategyView.showLoadingIndicator();

			if (recoveryStrategy instanceof WebstartRecoveryStrategy) {
				_uiStateManager.core().recoveryStrategyManager().startRecoveryStrategy(
						_currentRecoveryStrategy, _data['activationData']['authenticationOption'], handleWebstartRecoveryStrategy);
			} else {
				_uiStateManager.core().recoveryStrategyManager().startRecoveryStrategy(
						_currentRecoveryStrategy, _data['activationData']['authenticationOption']);
			}
		}


		// public methods

		this.title = function () {
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				return _uiStateManager.core().optionsManager().providerInfo().description();
			}

			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _recoveryStrategyView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, data) {
			_data = data;

			_providerInfoView.update(
					(_uiStateManager.core().context() === Context.SERVICE_PROVIDER) ?
							_uiStateManager.core().optionsManager().providerInfo() :
								_uiStateManager.core().cloudIdentitiesManager().providerInfo());

			_recoveryStrategyView.update(_data['recoveryStrategies']);

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView);
		};

		this.leave = function (doneCallback) {
			_data = null;
			_currentRecoveryStrategy = null;

			EventListenerRegistry.removeListener('RECOVERY_STRATEGY_SUCCEEDED', strategySucceeded);
			EventListenerRegistry.removeListener('RECOVERY_STRATEGY_FAILED', strategyFailed);

			_recoveryStrategyView.hideLoadingIndicator();

			Util.callCallbacks(doneCallback);
		};
	}

	RecoveryStrategyState.prototype = Object.create(UIState.prototype);

	return RecoveryStrategyState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/RecoveryStrategyState.js
// module id = 310
// module chunks = 3